<div class="out" [ngClass]="{border:border}" (mouseleave)="leave()" (mouseenter)="enter()">
  <div #optComponent class="options">
    <div class="opt" *ngFor="let opt of _options;let i = index"  kzLib (click)="selOption(i)">
      <img *ngIf="opt.img" [src]="opt.img">
      <span class="tx">{{opt.desc}}</span>
      <div class="check" [ngClass]="{selected:i == selected}"></div>
    </div>
  </div>
</div>
